import React, { useState } from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import _ from 'lodash';
import RuleForm from '../inputs/RuleForm';
import InlineDateSelect from '../inputs/InlineDateSelect';
import InlineRegionSelect from '../inputs/InlineRegionSelect';


const NewVendorRule = (props) => {
  const {
    form, type, onSubmit, initialValues, ...other
  } = props;
  const [date, setDate] = useState(initialValues.date || '');
  const [regions, setRegions] = useState(
    !_.isEmpty(initialValues.regions) ? initialValues.regions : [0]
  );

  const submit = (event) => {
    event.preventDefault();
    onSubmit({
      kind: 'new_vendor',
      regions: _.filter(regions),
      value: {
        date
      }
    });
  };

  const onReset = () => {
    setDate(initialValues.date || moment().format('YYYY-MM-DD'));
    setRegions(
      !_.isEmpty(initialValues.regions) ? initialValues.regions : [0]
    );
  };


  return (
    <RuleForm
      {...other}
      onSubmit={submit}
      onReset={onReset}
      isSubmitting={form.is_submitting}
    >
      <InlineRegionSelect
        value={regions}
        onChange={setRegions}
      />
      <InlineDateSelect
        value={date}
        label='Date'
        description='End date for adding vendors'
        onChange={setDate}
        placeholder='Select a date...'
        inputFormat='MMMM Do YYYY'
      />
    </RuleForm>
  );
};

NewVendorRule.defaultProps = {
  type: 'add',
  initialValues: {
    date: moment().format('YYYY-MM-DD')
  }
};

NewVendorRule.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  form: PropTypes.object.isRequired,
  type: PropTypes.string,
  initialValues: PropTypes.object,
};

export default NewVendorRule;
